// resources/js/form/products/heloc.js
let steps = [
    // Address (full address; replaces the former ZIP-only step)
    {
        title: "__address__",
        beforeCreate() {},
        beforeNextStep() {},
        fields: [
            {
                name: "address",
                placeholder: '',
                type: "fulladdress",
                value: null,
                fieldOuterClass: "col-md-8 offset-md-2",
            },
        ],
        hideButtonsSection: false,
    },
    // Credit score
    {
        beforeCreate() {},
        beforeNextStep() {},
        title: "__in_credit_situation__",
        hideButtonsSection: true,
        fields: [
            {
                name: "in_credit_situation",
                type: "radio",
                value: null,
                validationRules: "required",
                fieldOuterClass: "col-md-8 offset-md-2",
                choices: [
                    {"text": "__opt_in_credit_situation_good__", "value": "good"},
                    {"text": "__opt_in_credit_situation_fair__", "value": "fair"},
                    {"text": "__opt_in_credit_situation_low__", "value": "low"},
                    {"text": "__opt_in_credit_situation_cp__", "value":"in_consumer_proposal"},
                    {"text": "__opt_in_credit_situation_bk__", "value":"in_bankruptcy"},
                    {"text": "__opt_in_credit_situation_unknown__", "value": "unknown"},
                ],
            },
        ],
    },
    {
        beforeCreate: function() {
            // console.log('beforeCreate');
        },
        beforeNextStep: function() {
            // console.log('beforeNextStep');
        },
        title: "__product_purpose__",
        fields: [
            {
                // label: 'Loan Purpose',
                name: 'product_purpose',
                placeholder: '__select__',
                type: 'radio',
                value: null,
                validationRules: 'required',
                fieldOuterClass: 'col-md-8 offset-md-2',
                choices: [
                    {"text": "__opt_debt_consolidation__", "value": "Debt Consolidation"},
                    {"text": "__opt_cc_consolidation__", "value": "Credit Card Consolidation"},
                    {"text": "__opt_emergency_expense__", "value": "Emergency Expense"},
                    {"text": "__opt_car_repair__", "value": "Car Maintenance"},
                    {"text": "__opt_other__", "value": "Other"},
                ],
                hideIfHasValue: true,
            },
        ],
        hideButtonsSection: true,
        // isStepReadOnly: true,
        // isStepEditable: true,
    },
    // STARTS: unsecured amount if purpose debt/credit card consolidation
    {
        beforeCreate: function() {},
        beforeNextStep: function() {},
        title: '__cc_debt_amount__',
        fields: [
            {
                // label: 'Credit Card Debt Amount',
                name: 'cc_debt_amount',
                placeholder: '2500',
                type: 'radio',
                value: null,
                validationRules: 'required',
                fieldOuterClass: 'col-md-8 offset-md-2',
                choices: [
                    { "text":"__opt_debt_amounts_2500_less__", "value":"2500" },
                    { "text":"__opt_debt_amounts_2501_5000__", "value":"5000" },
                    { "text":"__opt_debt_amounts_5001_10000__", "value":"7500" },
                    { "text":"__opt_debt_amounts_10001_15000__", "value":"10000" },
                    { "text":"__opt_debt_amounts_15001_20000__", "value":"15000" },
                    { "text":"__opt_debt_amounts_20001_25000__", "value":"20000" },
                    { "text":"__opt_debt_amounts_25000_more__", "value":"25000" },
                    { "text":"__opt_debt_no_cc_debt__", "value":"0" },
                ],
                hideIfHasValue: true,
            },
        ],
        hideButtonsSection: true,
        hideIfCondition: (app) => {
            const options = [
                'Debt Consolidation',
                'Credit Card Consolidation',
            ];
            return !app.product_purpose || !options.includes(app.product_purpose);
        }
    },
    {
        beforeCreate: function() {},
        beforeNextStep: function() {},
        title: '__unsecured_debt_amount__',
        textTop: '__unsecured_debt_amount_definition__',
        fields: [
            {
                // label: 'Total Other Unsecured Debt',
                name: 'unsecured_debt_amount',
                placeholder: '2500',
                type: 'radio',
                value: null,
                validationRules: 'required',
                fieldOuterClass: 'col-md-8 offset-md-2',
                choices: (app) => {
                    const defaultChoices = [
                        { "text": "__opt_debt_amounts_2500_less__", "value": "2500" },
                        { "text": "__opt_debt_amounts_2501_5000__", "value": "5000" },
                        { "text": "__opt_debt_amounts_5001_10000__", "value": "7500" },
                        { "text": "__opt_debt_amounts_10001_15000__", "value": "10000" },
                        { "text": "__opt_debt_amounts_15001_20000__", "value": "15000" },
                        { "text": "__opt_debt_amounts_20001_25000__", "value": "20000" },
                        { "text": "__opt_debt_amounts_25000_more__", "value": "25000" },
                    ];

                    return app.cc_debt_amount && app.cc_debt_amount > 0
                        ? [...defaultChoices, { "text": "__opt_debt_no_unsecured_debt__", "value": "0" }]
                        : defaultChoices;
                },
                hideIfHasValue: true,
            },
        ],
        hideButtonsSection: true,
        hideIfCondition: (app) => {
            const options = [
                'Debt Consolidation',
                'Credit Card Consolidation',
            ];
            return !app.product_purpose || !options.includes(app.product_purpose);
        }
    },
    // ENDS: unsecured amount if purpose debt/credit card consolidation
    {
        title: "__more_information_needed__",
        beforeCreate() {},
        beforeNextStep: function() {},
        fields: [
            // {
            //     label: "__title_salutation__",
            //     name: "title",
            //     as: "select",
            //     type: "select",
            //     value: "",
            //     validationRules: "required",
            //     fieldOuterClass: "col-md-6",
            //     choices: [
            //         { value: "mr", text: "Mr" },
            //         { value: "ms", text: "Ms" },
            //         { value: "mrs", text: "Mrs" },
            //     ],
            // },
            {
                label: "__first_name__",
                name: "first_name",
                type: "text",
                value: null,
                validationRules: "required|name",
                fieldOuterClass: 'col-md-8 offset-md-2',
            },
            {
                label: "__last_name__",
                name: "last_name",
                type: "text",
                value: null,
                validationRules: "required|name",
                fieldOuterClass: 'col-md-8 offset-md-2',
            },
            {
                label: "__email_address__",
                name: "email",
                type: "text",
                value: null,
                validationRules: "required|email",
                fieldOuterClass: 'col-md-8 offset-md-2',
                attrs: {
                    maxlength: 50
                }
            },
            {
                label: "__address_city__",
                name: "city",
                type: "text",
                value: null,
                validationRules: "required",
                fieldOuterClass: 'col-md-8 offset-md-2',
                hideIfCondition: (app) => !!(app.address?.city || app.city),
                attrs: { maxlength: 50 },
            },
            {
                label: "__address_state__",
                name: "state",
                type: "select",
                value: null,
                validationRules: "required",
                fieldOuterClass: "col-md-8 offset-md-2",
                choices: [
                    {"text": "Alabama", "value": "AL"},
                    {"text": "Alaska", "value": "AK"},
                    {"text": "Arizona", "value": "AZ"},
                    {"text": "Arkansas", "value": "AR"},
                    {"text": "California", "value": "CA"},
                    {"text": "Colorado", "value": "CO"},
                    {"text": "Connecticut", "value": "CT"},
                    {"text": "Delaware", "value": "DE"},
                    {"text": "District Of Columbia", "value": "DC"},
                    {"text": "Florida", "value": "FL"},
                    {"text": "Georgia", "value": "GA"},
                    {"text": "Hawaii", "value": "HI"},
                    {"text": "Idaho", "value": "ID"},
                    {"text": "Illinois", "value": "IL"},
                    {"text": "Indiana", "value": "IN"},
                    {"text": "Iowa", "value": "IA"},
                    {"text": "Kansas", "value": "KS"},
                    {"text": "Kentucky", "value": "KY"},
                    {"text": "Louisiana", "value": "LA"},
                    {"text": "Maine", "value": "ME"},
                    {"text": "Maryland", "value": "MD"},
                    {"text": "Massachusetts", "value": "MA"},
                    {"text": "Michigan", "value": "MI"},
                    {"text": "Minnesota", "value": "MN"},
                    {"text": "Mississippi", "value": "MS"},
                    {"text": "Missouri", "value": "MO"},
                    {"text": "Montana", "value": "MT"},
                    {"text": "Nebraska", "value": "NE"},
                    {"text": "Nevada", "value": "NV"},
                    {"text": "New Hampshire", "value": "NH"},
                    {"text": "New Jersey", "value": "NJ"},
                    {"text": "New Mexico", "value": "NM"},
                    {"text": "New York", "value": "NY"},
                    {"text": "North Carolina", "value": "NC"},
                    {"text": "North Dakota", "value": "ND"},
                    {"text": "Ohio", "value": "OH"},
                    {"text": "Oklahoma", "value": "OK"},
                    {"text": "Oregon", "value": "OR"},
                    {"text": "Pennsylvania", "value": "PA"},
                    {"text": "Rhode Island", "value": "RI"},
                    {"text": "South Carolina", "value": "SC"},
                    {"text": "South Dakota", "value": "SD"},
                    {"text": "Tennessee", "value": "TN"},
                    {"text": "Texas", "value": "TX"},
                    {"text": "Utah", "value": "UT"},
                    {"text": "Vermont", "value": "VT"},
                    {"text": "Virginia", "value": "VA"},
                    {"text": "Washington", "value": "WA"},
                    {"text": "West Virginia", "value": "WV"},
                    {"text": "Wisconsin", "value": "WI"},
                    {"text": "Wyoming", "value": "WY"},
                ],
                hideIfCondition: (app) => !!(app.address?.province || app.state),
            },
            {
                label: "__phone_number__",
                name: "phone_number",
                type: "text",
                value: null,
                validationRules: "required|usPhone",
                attrs: {maxlength: 10, minlength: 10},
                fieldOuterClass: 'col-md-8 offset-md-2',
                hideIfHasValue: false,
                // textBottom: '__phone_number_sms_results__'
            },
        ],
        textBottomBelowActionButtons: '__rebound_consent_heloc__',
    },
];

export default steps;
